import { Toaster } from "react-hot-toast";
import AppRoutes from "./routes/AppRoutes";
import ErrorBoundary from "./components/ErrorBoundary";

// Template §4 — stays this small forever.
export default function App() {
  return (
    <>
      {/* THE LAST RESORT (H-4). AdminLayout carries its own route-level boundary so a page crash
          keeps the chrome; this one exists for what that cannot catch — a failure in the chrome
          itself, or before any layout has mounted. The Toaster sits OUTSIDE it so a toast can still
          be shown while the boundary is displaying. */}
      <ErrorBoundary>
        <AppRoutes />
      </ErrorBoundary>
      <Toaster position="top-right" toastOptions={{ style: { fontSize: 14 } }} />
    </>
  );
}
